import { SetStateAction } from "react";
import { stdObject } from "../../../../data/types/stdObject";
import { colors } from "../../../../data/colors";
import { sendData } from "../../../../services/sendData";

export const openCat = async (
  id: string,
  name: string,
  open: boolean | string = false,
  params: stdObject,
) => {
  const {
    t,
    categories,
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;
  console.log("id", id);
  if (open) {
    if (id === "" || Number(id) > 0) {
      setMsg2("loading");
      const responseCat: stdObject = await sendData({
        endPoint: "callCat",
        payload: {
          id: open === "new" ? "" : id,
        },
        logoutAction,
      });
      console.log("responseCat", responseCat);
      if (responseCat.success && responseCat.status) {
        if (open === "new") {
          responseCat.info.PADCAT = id;
        }
        closeMsg(2);
        setMsg("catModal");
        setModalData({
          id: responseCat.info.CODCAT,
          title:
            id === "" || open === "new"
              ? t("p.newCAT")
              : responseCat.info.NOMCAT,
          mainColor: colors.items,
          inputs: [
            {
              code: "IMGCAT",
              label: t("p.image"),
              type: "image",
              tabId: 0,
              imageCode: responseCat.info.CODCAT,
              imageFormat: responseCat.info.FORCAT,
            },
            { code: "NOMCAT", label: t("c.NOM"), type: "text", tabId: 0 },
            {
              code: "PADCAT",
              label: t("c.PAD"),
              type: "select",
              options: [
                { label: t("p.root"), value: "" },
                ...categories
                  .filter(
                    (e: stdObject) => e.CODCAT !== responseCat.info.CODCAT,
                  )
                  .map((e: stdObject) => {
                    return { label: e.NOMCAT, value: e.CODCAT };
                  }),
              ],
              tabId: 0,
            },
            { code: "WEBCAT", label: t("c.WEB"), type: "checkbox", tabId: 0 },
            { code: "SEVCAT", label: t("c.SEV"), type: "checkbox", tabId: 0 },
            ...responseCat.children.map((e: stdObject) => {
              return {
                code: "WEBCAT",
                label: e.NOMCAT,
                type: "list",
                tabId: 1,
              };
            }),
            ...responseCat.items.map((e: stdObject) => {
              return {
                code: "WEBCAT",
                label: e.NOMART,
                type: "list",
                tabId: 2,
              };
            }),
            {
              code: "COMM",
              onChange: (e: {
                target: { value: SetStateAction<string> };
              }) => {},
              tabId: 3,
            },
          ],
        });
        setWindowValues({
          NOMCAT: responseCat.info.NOMCAT,
          PADCAT: responseCat.info.PADCAT,
          WEBCAT: responseCat.info.WEBCAT,
          SEVCAT: responseCat.info.SEVCAT,
          commissions: responseCat.commissions,
        });
      } else {
        setMsg2("error");
      }
    }
  } else {
    setMsg("custom1");
    setModalData({
      title: name,
      label: t("p.whatDoYouWantToDo"),
      buttons: [
        {
          label: t("p.edit"),
          onClick: () => openCat(id, name, true, params),
          color: colors.green,
        },
        {
          label: t("p.addSubcategory"),
          onClick: () => openCat(id, name, "new", params),
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    });
  }
};
